import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changeConfigDataValue, changeFlexibleSpecValue } from 'redux/modules/audience';
import { categorySearch } from 'redux/modules/audienceBehaviors';
import * as _ from 'lodash';
import MenuItem from 'material-ui/MenuItem';
import Chip from 'material-ui/Chip';
import SelectField from 'material-ui/SelectField';
var AudienceBehaviors = (_dec = connect(function (state) {
  return {
    exclusions: state.audience.FacebookTargetingConfig.data.exclusions,
    organization: state.organization.current
  };
}, {
  changeConfigDataValue: changeConfigDataValue,
  changeFlexibleSpecValue: changeFlexibleSpecValue,
  categorySearch: categorySearch
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceBehaviors, _Component);

  var _super = _createSuper(AudienceBehaviors);

  function AudienceBehaviors(props) {
    var _this;

    _classCallCheck(this, AudienceBehaviors);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleValueSelected", function (v) {
      v.type = 'behaviors';

      _this.props.changeFlexibleSpecValue(_this.props.specIndex, v);
    });

    _defineProperty(_assertThisInitialized(_this), "handleExclusionValueSelected", function (v) {
      var updatedExclusions = Object.assign({}, _this.props.exclusions);
      var strippedNewValue = {
        id: v.id,
        name: v.name
      }; //    updatedExclusions.interests = _.unionBy(updatedExclusions.interests, [strippedNewValue], 'id');

      updatedExclusions.behaviors = [].concat(_toConsumableArray(updatedExclusions.behaviors), [strippedNewValue]);

      _this.props.changeConfigDataValue('exclusions', updatedExclusions);
    });

    _this.state = {
      dataSource: []
    };
    return _this;
  }

  _createClass(AudienceBehaviors, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      this.props.categorySearch('behaviors').then(function (res) {
        var data = _.filter(res.data, function (d) {
          if (d.hasOwnProperty('country') && d.country === 'GB') {
            return false;
          }

          if (d.name.includes('Expats')) {
            return false;
          }

          if (d.name.includes('value goods')) {
            return false;
          }

          return d;
        });

        _this2.setState({
          dataSource: data
        });
      });
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this3 = this;

      var isExclusion = this.props.isExclusion;
      var selectItems = this.state.dataSource.map(function (d, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: index,
          key: index,
          primaryText: d.name
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3",
        style: {
          lineHeight: '46px',
          color: '#616161'
        }
      }, "Behaviors"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, /*#__PURE__*/React.createElement(SelectField, {
        fullWidth: true,
        onChange: function onChange(event, index, value) {
          _this3.props.isExclusion ? _this3.handleExclusionValueSelected(_this3.state.dataSource[index]) : _this3.handleValueSelected(_this3.state.dataSource[index]);
        }
      }, selectItems)));
    }
  }]);

  return AudienceBehaviors;
}(Component)) || _class);
export { AudienceBehaviors as default };
AudienceBehaviors.defaultProps = {
  specIndex: 0
};